export default __webpack_public_path__ + "static/media/fejring_farve.760df92d.png";